import { Injectable } from '@angular/core';
import {PageRequest} from '../../shared/models/page-request.interface';
import {Observable, throwError} from 'rxjs';
import {Page} from '../../shared/models/page.interface';
import {TemplatesSearch} from '../models/templates-search.interface';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Templates} from '../models/templates.interface';
import {ApiHttpResponse} from '../../shared/models/api-http-response.interface';
import {catchError, map} from 'rxjs/operators';
import {Master} from '../models/master.interface';

const TEMPLATES_API = environment.apiUrl + 'templates';

@Injectable({
  providedIn: 'root'
})
export class TemplatesService {

  constructor(private http: HttpClient) { }

  static buildSearchParams(search: TemplatesSearch): string {
    let searchParams = '';
    if (search.description && search.description !== '') {
      searchParams += `&description=${search.description}`;
    }
    if (search.category) {
      searchParams += `&category=${search.category}`;
    }
    if (search.subject && search.subject !== '') {
      searchParams += `&subject=${search.subject}`;
    }
    if (search.status && search.status !== '') {
      searchParams += `&status=${search.status}`;
    }
    return searchParams;
  }

  getAll(search: TemplatesSearch, pageRequest: PageRequest = {page: 0, size: 100}): Observable<Page<Templates>> {
    let url = `${TEMPLATES_API}?size=${pageRequest.size}&page=${pageRequest.page}`;
    const searchParams = TemplatesService.buildSearchParams(search);
    if (pageRequest.sort && pageRequest.direction) {
      url = url + `&sort=${this.getSortCode(pageRequest.sort)},${pageRequest.direction}`;
    }
    return this.http.get<Page<Templates>>(url + searchParams);

  }

  getCategories(): Observable<Master[]> {
    return this.http.get<Master[]>(`${TEMPLATES_API}/categories`);
  }

  editTemplate(dto: Templates): Observable<ApiHttpResponse<Templates>> {
    return this.http.put<ApiHttpResponse<Templates>>(`${TEMPLATES_API}`, dto)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<Templates>) => {
          return res;
        })
      );
  }

  updateTemplate(id: number): Observable<ApiHttpResponse<Templates>> {
    return this.http.put<ApiHttpResponse<Templates>>(`${TEMPLATES_API}/update`, id)
      .pipe(
        catchError(err => {
          return throwError(err);
        }),
        map((res: ApiHttpResponse<Templates>) => {
          return res;
        })
      );
  }

  deleteTemplate(id: number): Observable<HttpResponse<any>> {
    return this.http.delete(`${TEMPLATES_API}/${id}`, {observe: 'response'})
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  private getSortCode(sort: string): string {
    switch (sort) {
      case 'open':
        return 'isReportingAvailable';
      default:
        return sort;
    }
  }
}
